import { useMutation } from "@tanstack/react-query";
import { api } from "@/lib/api";

/**
 * Email-verification flows on the legacy `/auth/*` controller (anonymous).
 *
 * verify-email returns { success, status } where status is one of
 * SUCCESS | ALREADY_VERIFIED | TOKEN_EXPIRED | INVALID_TOKEN.
 * resend-verification returns a neutral { success, message }.
 */

export type VerifyEmailStatus =
  | "SUCCESS"
  | "ALREADY_VERIFIED"
  | "TOKEN_EXPIRED"
  | "INVALID_TOKEN";

export interface VerifyEmailResult {
  success: boolean;
  status: VerifyEmailStatus;
}

export function useVerifyEmail() {
  return useMutation({
    mutationFn: (token: string) =>
      api.post<VerifyEmailResult>("/auth/verify-email", { token })
  });
}

export function useResendVerification() {
  return useMutation({
    mutationFn: (email: string) =>
      api.post<{ success: boolean; message: string }>(
        "/auth/resend-verification",
        { email }
      )
  });
}
